import { TAdminCharge } from "~/types/admin-charge";
import { baseService } from "../base";
import { PaginationResponse } from "../type";
import {
  CreateAdminChargeParams,
  UpdateAdminChargeParams,
  QueryAdminChargeParams,
} from "./admin-charge.types";

export const adminChargeServices = {
  getAdminCharges: async (params?: QueryAdminChargeParams) => {
    const { data } = await baseService.get<PaginationResponse<TAdminCharge>>(
      "/admin-charges",
      {
        params: params ?? {
          page: 1,
          pageSize: 50,
        },
      }
    );
    return data;
  },

  getAdminCharge: async (id: string) => {
    const { data } = await baseService.get<TAdminCharge>(
      `/admin-charges/${id}`
    );
    return data;
  },

  createAdminCharge: async (data: CreateAdminChargeParams) => {
    const { data: response } = await baseService.post<TAdminCharge>(
      "/admin-charges",
      data
    );
    return response;
  },

  updateAdminCharge: async ({
    id,
    data,
  }: {
    id: string;
    data: UpdateAdminChargeParams;
  }) => {
    const { data: response } = await baseService.patch<TAdminCharge>(
      `/admin-charges/${id}`,
      data
    );
    return response;
  },

  deleteAdminCharge: async (id: string) => {
    const { data } = await baseService.delete(`/admin-charges/${id}`);
    return data;
  },
};
